/* global axios */
import ApiClient from './ApiClient';

class GrowthLinksAPI extends ApiClient {
  constructor() {
    super('growth_links', { accountScoped: true });
  }

  create(growthLink) {
    return axios.post(this.url, { growth_link: growthLink });
  }

  update(id, growthLink) {
    return axios.patch(`${this.url}/${id}`, { growth_link: growthLink });
  }

  getQr(id) {
    return axios.get(`${this.url}/${id}/qr`, { responseType: 'text' });
  }
}

export default new GrowthLinksAPI();
